import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CardBody, Card, Label, Form, FormGroup, Col, Button, Input } from 'reactstrap'
import { toast } from 'react-toastify';
import { uploadRatingsData } from './action'
import { Preloading as preloading } from '../../../components/UI/Preloader/action';

class CounterpartyRatingsDataUpload extends Component {

    state = { ratingsDataFile: undefined };

    componentDidUpdate(prevProps) {
        if (this.props.ratingsDataUploadResponse !== prevProps.ratingsDataUploadResponse) {
            this.props.preloading(false);
            if (this.props.ratingsDataUploadResponse.status === "SUCCESS") {
                toast.success(
                    <div>
                        <i ></i>&nbsp; Data Uploaded Successfully !
                    </div>
                );
                this.setState({ratingsDataFile  :undefined});
                this.setState({ ratingsDataUpdateFile: undefined});
            } else {
                let message = this.props.ratingsDataUploadResponse.data.message ? this.props.ratingsDataUploadResponse.data.message : this.props.ratingsDataUploadResponse.data;
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;{message}
                    </div>
                );
            }
        }
    }

    componentWillUnmount() { }

    submitDataToServer = (e, update) => {
        e.preventDefault();
        this.props.uploadRatingsData({
            file: update ? this.state.ratingsDataUpdateFile : this.state.ratingsDataFile,
            update: update
        })
        this.props.preloading(true);
    }

    uploadRatingsFile = (e, update) => {
        e.preventDefault();
        let file = e.target.files[0];
        if (file && file.name && file.name.endsWith(".xlsx")) {
            if (update) {
                this.setState({ ratingsDataUpdateFile : file})
                this.setState({ ratingsDataFile: undefined });
            } else {
                this.setState({ ratingsDataFile: file });
                this.setState({ ratingsDataUpdateFile: undefined});
            }
        } else {
            this.setState({ ratingsDataFile: undefined });
            this.setState({ ratingsDataUpdateFile: undefined});
            e.target.value = null;
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Please upload Excel File only !
                </div>
            );
        }
        e.target = null;
    }

    render() {
        return (<Col>
            <div className="justify-content-between align-items-center mb-3">
                <h4 className="mb-0 text-center">Ratings Data Upload</h4>
            </div>

            <Card>
                <CardBody >
                    <Form className="w-100" >
                        <FormGroup style={{ marginLeft: "1rem" }} row>
                            <Label sm={6}>Upload New Data </Label>
                            <Col sm={10}>
                                <Input type="file" name="ratings-new-data" id="ratings-new-data" onChange={(e) => this.uploadRatingsFile(e, false)} className="btn   position-relative " style={{ borderColor: "#007bff" }} />
                            </Col>
                            <Col style={{ marginLeft: "1rem" }} sm={6}>
                                <Button disabled={!this.state.ratingsDataFile} color="primary" onClick={(e) => this.submitDataToServer(e, false)} > Upload Data </Button>
                            </Col>
                        </FormGroup>
                        <FormGroup style={{ marginLeft: "1rem" }} row>
                            <Label sm={6}>Update Existing Data </Label>
                            <Col sm={10}>
                                <Input type="file" name="ratings-data-update" id="ratings-data-update" onChange={(e) => this.uploadRatingsFile(e, true)} className="btn   position-relative " style={{ borderColor: "#007bff" }} />
                            </Col>
                            <Col style={{ marginLeft: "1rem" }} sm={6}>
                                <Button disabled={!this.state.ratingsDataUpdateFile} color="primary" onClick={(e) => this.submitDataToServer(e, true)} > Upload Data </Button>
                            </Col>
                        </FormGroup>
                    </Form>
                </CardBody>
            </Card>
        </Col>
        )
    }
}

const mapStateToProps = (state) => ({
    ratingsDataUploadResponse: state.ratingsUploadData.ratingsDataUploadResponse,
})
const mapDispatchToProps = (dispatch) => ({
    preloading: data => { dispatch(preloading(data)) },
    uploadRatingsData: data => { dispatch(uploadRatingsData(data))}
});

export default connect(mapStateToProps, mapDispatchToProps)(CounterpartyRatingsDataUpload);